module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedExtraLight.d5046c7.woff";